/* OnlyCurve — CRO Edition · « Crée ton set » mix block on the product page: this piece + other models, same automatic discounts */
(function () {
  'use strict';
  var OC = (window.OC = window.OC || {});
  var qs = function (s, r) { return (r || document).querySelector(s); };
  var qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { return OC.formatMoney ? OC.formatMoney(c) : (c / 100).toFixed(2); };
  function parse(el) { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }

  function initMix(box) {
    if (!box || box._ocMix) return; box._ocMix = true;
    var data = parse(qs('[data-mix-json]', box)), L = parse(qs('[data-mix-strings]', box)) || {}, T = OC.strings || {};
    if (!data || !data.main) return;
    var tiers = data.tiers || [0], free = !!data.free, threshold = data.threshold || 0;
    var mainRow = qs('[data-mix-main]', box), list = qs('[data-mix-list]', box);
    var rows = qsa('[data-mix-item]', box);
    var tabs = qsa('[data-mix-tab]', box), panels = qsa('[data-mix-panel]', box);
    var bar = {
      count: qs('[data-mix-count]', box), sum: qs('[data-mix-sum]', box), full: qs('[data-mix-full]', box),
      free: qs('[data-mix-free]', box), fee: qs('[data-mix-fee]', box), save: qs('[data-mix-save]', box),
      next: qs('[data-mix-next]', box), nextText: qs('[data-mix-next-text]', box),
      btn: qs('[data-mix-add]', box), label: qs('[data-mix-add-label]', box), err: qs('[data-mix-error]', box)
    };
    var touched = false;

    function prodOf(row) { return row === mainRow ? data.main : data.items[parseInt(row.getAttribute('data-index'), 10)]; }
    function pct(n) { return n > 1 ? (tiers[Math.min(n, 4) - 1] || 0) : 0; }
    // like Shopify: the % is taken per cart line, rounded down to the cent
    function after(price, x) { return price - Math.floor(price * x / 100); }
    function choice(row) {
      var prod = prodOf(row), out = [];
      for (var i = 0; i < prod.options.length; i++) { var s = qs('[data-mix-option="' + i + '"]', row); out[i] = s && s.value ? s.value : null; }
      return out;
    }
    function variantOf(row) {
      var prod = prodOf(row);
      if (!prod) return null;
      if (prod.variants.length === 1) return prod.variants[0];
      var c = choice(row);
      if (c.some(function (x) { return x === null; })) return null;
      return prod.variants.find(function (v) { return v.o.every(function (o, i) { return o === c[i]; }); }) || null;
    }
    function canBuy(prod, c, i, val) {
      return prod.variants.some(function (v) {
        if (v.o[i] !== val || !v.a) return false;
        for (var j = 0; j < v.o.length; j++) { if (j !== i && c[j] !== null && v.o[j] !== c[j]) return false; }
        return true;
      });
    }
    function syncOptions(row) {
      var prod = prodOf(row), c = choice(row);
      qsa('[data-mix-option]', row).forEach(function (s) {
        var i = parseInt(s.getAttribute('data-mix-option'), 10);
        qsa('option', s).forEach(function (o) {
          if (!o.value) return;
          if (!o.hasAttribute('data-label')) o.setAttribute('data-label', o.textContent);
          var ok = canBuy(prod, c, i, o.value);
          o.disabled = !ok && o.value !== s.value;
          o.textContent = o.getAttribute('data-label') + (ok ? '' : ' — ' + (T.soldOutShort || ''));
        });
      });
    }
    function picked() { return rows.filter(function (r) { var cb = qs('[data-mix-check]', r); return cb && cb.checked; }); }
    function setPrice(row, price, x) {
      var p = qs('[data-mix-price]', row), w = qs('[data-mix-was]', row);
      if (p) p.textContent = money(after(price, x));
      if (w) { w.hidden = !x; w.textContent = x ? money(price) : ''; }
    }
    function missingRow() {
      var all = [mainRow].concat(picked());
      for (var k = 0; k < all.length; k++) { if (!variantOf(all[k])) return all[k]; }
      return null;
    }
    function swapImg(row) {
      var v = variantOf(row), im = qs('[data-mix-img] img', row);
      if (v && v.img && im) { im.removeAttribute('srcset'); im.src = v.img; }
    }
    // category tabs: 3 best-sellers per category, one category visible at a time
    function showTab(k) {
      k = String(k);
      tabs.forEach(function (t) { var on = t.getAttribute('data-mix-tab') === k; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-mix-panel') !== k; });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { showTab(t.getAttribute('data-mix-tab')); });
      t.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(t), to = e.key === 'ArrowRight' ? i + 1 : e.key === 'ArrowLeft' ? i - 1 : -2;
        if (to === -2 || !tabs[to]) return;
        e.preventDefault(); tabs[to].focus(); showTab(tabs[to].getAttribute('data-mix-tab'));
      });
    });

    function render() {
      var sel = picked(), n = 1 + sel.length, x = pct(n), shown = pct(Math.max(2, n));
      var mv = variantOf(mainRow), mainPrice = mv ? mv.p : data.main.price;
      setPrice(mainRow, mainPrice, n > 1 ? x : 0);
      var total = after(mainPrice, x), full = mainPrice;
      rows.forEach(function (r) {
        var on = sel.indexOf(r) > -1, v = variantOf(r), price = v ? v.p : prodOf(r).price;
        setPrice(r, price, shown);
        r.classList.toggle('is-selected', on);
        var ss = qs('[data-mix-selects]', r); if (ss) ss.hidden = !on;
        if (on) { total += after(price, x); full += price; }
      });
      [mainRow].concat(rows).forEach(syncOptions);
      panels.forEach(function (p) {
        var k = p.getAttribute('data-mix-panel'), c = qsa('[data-mix-check]', p).filter(function (x) { return x.checked; }).length;
        var b = qs('[data-mix-tab="' + k + '"] [data-mix-tab-count]', box);
        if (b) { b.hidden = !c; b.textContent = c; }
      });
      if (bar.count) bar.count.textContent = n === 1 ? (L.one || '') : (L.count || '[count]').replace('[count]', n) + (x ? ' · -' + x + '%' : '');
      if (bar.sum) bar.sum.textContent = money(total);
      if (bar.full) { bar.full.hidden = total >= full; bar.full.textContent = money(full); }
      var isFree = (n > 1 && free) || (threshold > 0 && total >= threshold);
      if (bar.free) bar.free.hidden = !isFree;
      if (bar.fee) bar.fee.hidden = isFree;
      if (bar.save) { bar.save.hidden = total >= full; bar.save.textContent = (L.saving || '').replace('[amount]', money(full - total)); }
      var nx = pct(Math.min(n + 1, 4)), gainFree = free && !isFree;
      if (bar.next) bar.next.hidden = !nx || nx <= x;
      if (bar.nextText) bar.nextText.textContent = ((gainFree && L.nextFree) || L.next || '').replace('[percent]', nx);
      var miss = n > 1 ? missingRow() : null;
      if (bar.label) bar.label.textContent = n < 2 ? (L.pickOne || '') : (miss ? (L.chooseCta || '') : (T.addSet || '[count]').replace('[count]', n));
      if (bar.btn) bar.btn.classList.toggle('is-waiting', n < 2 || !!miss);
      if (bar.err) bar.err.hidden = true;
    }

    function shake(el) { el.classList.remove('is-error'); void el.offsetWidth; el.classList.add('is-error'); }
    function flag(row) {
      var panel = row.closest('[data-mix-panel]');
      if (panel && panel.hidden) showTab(panel.getAttribute('data-mix-panel'));
      shake(row);
      row.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var s = qsa('[data-mix-option]', row).find(function (x) { return !x.value; });
      if (s) setTimeout(function () { try { s.focus({ preventScroll: true }); } catch (e) { s.focus(); } }, 400);
    }
    function error(msg) { if (bar.err && msg) { bar.err.hidden = false; bar.err.textContent = msg; } }

    function add() {
      var sel = picked();
      if (!sel.length) { if (list) { shake(list); list.scrollIntoView({ behavior: 'smooth', block: 'center' }); } error(L.pickError); return; }
      var miss = missingRow();
      if (miss) { flag(miss); error(L.chooseError); return; }
      var vs = [variantOf(mainRow)].concat(sel.map(variantOf));
      if (vs.some(function (v) { return !v || !v.a; })) { error(T.unavailable); return; }
      var counts = {}, order = [];
      vs.forEach(function (v) { if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); } counts[v.id]++; });
      var items = order.map(function (id) { return { id: id, quantity: counts[id] }; });
      if (!OC.cart || !OC.cart.add) return;
      bar.btn.classList.add('is-loading');
      OC.cart.add(items, {})
        .catch(function (e) { error(e && e.message ? e.message : T.cartError); })
        .then(function () { bar.btn.classList.remove('is-loading'); });
    }

    box.addEventListener('change', function (e) {
      var t = e.target, row = t.closest('[data-mix-main], [data-mix-item]');
      if (!row) return;
      if (t.hasAttribute('data-mix-option')) { row.classList.remove('is-error'); if (row === mainRow) touched = true; swapImg(row); }
      if (t.hasAttribute('data-mix-check') && list) list.classList.remove('is-error');
      render();
    });
    if (bar.btn) bar.btn.addEventListener('click', function (e) { e.preventDefault(); add(); });

    // piece 1 follows the colour and size she picks in the buy box above (until she changes it here)
    function follow(opts) {
      if (!opts || touched) return;
      qsa('[data-mix-option]', mainRow).forEach(function (s) {
        var i = parseInt(s.getAttribute('data-mix-option'), 10);
        if (opts[i] !== undefined && opts[i] !== null) s.value = opts[i];
      });
      swapImg(mainRow); render();
    }
    var pdp = document.querySelector('[data-product]');
    if (pdp) {
      pdp.addEventListener('oc:variant-change', function (e) { var v = e.detail && e.detail.variant; if (v) follow(v.options); });
      var idIn = pdp.querySelector('form[data-product-form] [name="id"]');
      var start = idIn && idIn.value ? data.main.variants.find(function (v) { return String(v.id) === String(idIn.value); }) : null;
      if (start) follow(start.o);
    }
    qsa('[data-set-mix-link]').forEach(function (a) { a.hidden = false; });
    render();
  }

  OC.initMix = initMix;
  function boot() { qsa('[data-set-mix]').forEach(initMix); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();